import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import formService from "services/feedback-service";
import AddServiceModal from "modals/services/AddServicesModal";
import UpdateServiceModal from "modals/services/UpdateServiceModal"; // Corrected import path
import ServicesTable from "./ServicesTable";

export default function Services() {
  const [servicesData, setServicesData] = useState([]);
  const [selectedService, setSelectedService] = useState([]); // Initialize with an empty array

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(true); // Initialize as true

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpen = (type) => {
    if (type === "add") {
      setOpenAddModal(true);
    } else if (type === "update") {
      setOpenUpdateModal(true);
    }
  };

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    formService
      .getAllServices()
      .then((e) => {
        setServicesData(e);
      })
      .catch((err) => {
        setError(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  // useEffect(() => {
  //   setDisabled(selectedService.length === 0); // Update disabled state based on selectedService
  // }, [selectedService]);

  useEffect(() => {
    if (!selectedService?.length === 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectedService]);

  return (
    <Box
      sx={{
        p: "20px",
        backgroundColor: "#1c1948",
        fontFamily: "Poppins",
      }}
    >
      <AddServiceModal
        handleClose={() => setOpenAddModal(false)}
        open={openAddModal}
        updateTableFunction={handleGetAll}
      />
      <UpdateServiceModal
        handleClose={() => setOpenUpdateModal(false)}
        open={openUpdateModal}
        data={selectedService && selectedService[0]}
        updateTableFunction={handleGetAll}
      />
      <Box
        borderRadius="10px"
        boxShadow="3px 2px 15px 3px rgba(100, 100, 100, 0.8)"
        p="1rem"
        sx={{ backgroundColor: "rgba(240, 240, 240, 1)" }}
      >
        <Divider>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontSize: "25px",
              fontFamily: "Poppins",
              fontWeight: "bold",
            }}
          >
            Services
          </Typography>
        </Divider>
        <Box>
          {error}
          <ServicesTable
            data={servicesData}
            setSelectedService={setSelectedService}
            loadingState={loading}
            updateTableFunction={handleGetAll}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
          }}
        >
          <Box>
            <Button
              onClick={() => handleOpen("add")}
              sx={{
                backgroundColor: "#1c1948",
                color: "white",
                width: "10rem",
                "&:hover": {
                  color: "black",
                  backgroundColor: "#11edd2",
                },
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              Add
            </Button>
          </Box>
          <Box>
            <Button
              onClick={() => handleOpen("update")}
              disabled={disabled}
              sx={{
                width: "10rem",
                fontFamily: "Poppins",
                backgroundColor: "#564ee2",
                color: "white",
                "&:hover": {
                  color: "black",
                  backgroundColor: "#11edd2",
                },
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
